import React from 'react';
import { useFeatureFlag } from '@americanexpress/one-experiments';
import { locales } from '@americanexpress/conditional-features';
import { getActiveLocaleSelector, getTenancySelector } from '@americanexpress/travel-selectors';
import { useSelector } from 'react-redux';
import TulipsSmartFill from './TulipsSmartFill';
import LxpSmartFill from './LxpSmartFill';
import LocationsSmartFill from './LocationsSmartFill';
import { FHR_KEY, THC_KEY } from '../../constants/categoryConstants';
import locationContext from '../../context/locationsContext';

const SmartFillVersion = () => {
  const locale = useSelector(getActiveLocaleSelector);
  const {
    config: {
      lineOfBusiness,
    },
  } = React.useContext(locationContext);
  const tenancy = useSelector(getTenancySelector);
  const { properties } = useFeatureFlag({ featureFlagName: `prebooking_LXP_smartfill-${lineOfBusiness}` });

  const isFhrThc = lineOfBusiness === FHR_KEY || lineOfBusiness === THC_KEY;

  const shouldDisplayLxpSmartFill = !isFhrThc && properties?.[tenancy]?.includes(locale);

  const shouldDisplayLocationsSmartFill = (locale !== locales.EN_US)
    && isFhrThc;

  if (shouldDisplayLxpSmartFill) {
    return <LxpSmartFill />;
  }
  if (shouldDisplayLocationsSmartFill) {
    return <LocationsSmartFill />;
  }
  return <TulipsSmartFill />;
};

export default SmartFillVersion;
